import React from 'react'
import FeatureSection from '../category-components/AussieFeatureSection'
import AussieProduct from '../category-components/AussieProduct'
// import CategoryWhyChooseUs from '../category-components/CategoryWhyChooseUs'
import BreadcrumbBanner from "../components/BreadcrumbBanner";
import SeoHelmet from "../Seo/SeoHelmet";
import AussieChoose from '../category-components/AussieChoose';

const AussieBreakfast = () => {
  return (
    <div>
         <SeoHelmet page="aussie-breakfast" />
      <BreadcrumbBanner
        title="Aussie Breakfast"
        backgroundImage="/Images/banner-about.jpg"
      />
      <FeatureSection/>
      <AussieProduct/>
     <AussieChoose/>
    </div>
  )
}

export default AussieBreakfast